import { useEffect } from "react";
import { RECEIVE_NOTES, TodayNotes } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitTodayActions } from "./toolkitTodayStore";

export function useToolkitTodayRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== RECEIVE_NOTES) {
        return;
      }

      toolkitTodayActions.setNotes((action.payload ?? {}) as TodayNotes);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
